import BaseLine, { IEndInfo } from '../../line-base';

class BentConnector2 extends BaseLine {
    public svgPathInRect = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => `M${x + endInfo.head} ${y} L${x + w} ${y} L${x + w} ${y + h - endInfo.tail}`;

    public setLineInfo = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => {
        this.startPos = {
            x: x + endInfo.head,
            y,
        };
        this.endPos = {
            x: x + w,
            y: y + h - endInfo.tail,
        };
    };
}

export default BentConnector2;
